/**
 * Product Datasheet
 * - Re-fetch section HTML via Section Rendering API on variant change.
 * - Delegated click handler for collapsible <details> so it survives innerHTML replacement.
 */
(function () {
  function animateOpen(details) {
    details.setAttribute('open', '');
    details.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      details.classList.add('is-open');
    });
  }

  function animateClose(details) {
    if (!details.hasAttribute('open')) return;
    details.classList.remove('is-open');
    details.setAttribute('aria-expanded', 'false');
    var content = details.querySelector('.accordion__content');
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      details.removeAttribute('open');
    }
    setTimeout(finish, 350);
    if (content) {
      content.addEventListener('transitionend', function handler(evt) {
        if (evt.target !== content) return;
        content.removeEventListener('transitionend', handler);
        finish();
      });
    } else {
      finish();
    }
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('[data-product-datasheet] details.accordion > summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details) return;
    e.preventDefault();
    if (details.hasAttribute('open')) {
      animateClose(details);
    } else {
      animateOpen(details);
    }
  });

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var datasheet = document.querySelector('[data-product-datasheet]');
    if (!datasheet) return;

    var prevDetails = datasheet.querySelector('details.accordion');
    var wasOpen = prevDetails ? prevDetails.hasAttribute('open') : null;
    var wasIsOpen = prevDetails ? prevDetails.classList.contains('is-open') : null;

    var sectionId = e.detail.sectionId;
    var url =
      window.location.pathname +
      '?variant=' + variant.id +
      '&section_id=' + sectionId;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDatasheet = doc.querySelector('[data-product-datasheet]');
        if (!newDatasheet) return;

        if (prevDetails) {
          var newDetails = newDatasheet.querySelector('details.accordion');
          if (newDetails) {
            if (wasOpen) {
              newDetails.setAttribute('open', '');
              newDetails.setAttribute('aria-expanded', 'true');
            } else {
              newDetails.removeAttribute('open');
              newDetails.setAttribute('aria-expanded', 'false');
            }
            if (wasIsOpen) {
              newDetails.classList.add('is-open');
            } else {
              newDetails.classList.remove('is-open');
            }
          }
        }

        datasheet.innerHTML = newDatasheet.innerHTML;
      });
  });
})();
